import React, { useEffect, useState } from "react";
import Credin from "../../assets/Credin Logo (1).svg";
import axios from "axios";
import { url } from "../../App";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Link,useNavigate } from "react-router-dom";

export default function CreateUser() {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [data, setData] = useState([]);
  useEffect(() => {
    setOpen(true);
    axios
      .post(url + "/api/loginid", {
        agnetCode: localStorage.getItem("CodeCPV"),
      })
      .then((res) => {
        setOpen(false);
        // console.log(res);
        if(res.data.auth === false){
          toast.error(res.data.msg);
          setTimeout(() => {
            navigate("/");
          }, 1000);
        }
        else {
          setData(res.data);
        }
      })
      .catch((err) => {
        setOpen(false);
        console.log(err);
      });
  }, [navigate]);

  const [username, setUsername] = useState("");
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [companyCode, setCompanyCode] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [branchName, setBranchName] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Creating User");
    axios
      .post(url + "/api/update/user", {
        name: username,
        email: userId,
        password: password,
        code: companyCode,
        branchLat: latitude,
        branchLong: longitude,
        branchName: branchName,
      })
      .then((res) => {
        // console.log(res);
        if (res.data.msg === "User successfully created or updated") {
          toast.success(res.data.msg);
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        }
        else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleDelete = (email) => {
    let text = "Are you sure you want to delete " + email + "?";
    if (window.confirm(text) === true) {
      axios.post(url + "/api/deleteuser", {
        email: email
      })
      .then((res) => {
        // console.log(res);
        if(res.data.auth === true){
          toast.success(res.data.msg);
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        }
        else{
          toast.error(res.data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      }
      else{
        toast.info("User Not Deleted");
      }
  }
  return (
    <div className="main-login">
      <div style={{ margin: "2rem" }}>
        <img src={Credin} alt="Credin Logo" width="150" />
      </div>
      <div className="container-create-user">
        <div
          style={{
            fontWeight: "bolder",
            fontSize: "1.5rem",
            margin: ".5rem 0",
          }}
        >
          Create User
        </div>
        <form onSubmit={handleSubmit}>
          <div className="div-login">
            <label>
              Enter Name <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              value={username}
              name="username"
              required
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div className="div-login">
            <label>
              Enter Email Id <span style={{ color: "red" }}>*</span>
            </label>
            <input
              required
              name="user-id"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
            />
          </div>
          <div className="div-login">
            <label>
              Enter Password <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              required
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="div-login">
            <label>
              Enter Company Code <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              required
              name="company-code"
              value={companyCode}
              onChange={(e) => setCompanyCode(e.target.value)}
            />
          </div>
          <div className="div-login">
            <label>
              Enter Latitude <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              required
              name="latitude"
              value={latitude}
              onChange={(e) => setLatitude(e.target.value)}
            />
          </div>
          <div className="div-login">
            <label>
              Enter Longitude <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              required
              name="longitude"
              value={longitude}
              onChange={(e) => setLongitude(e.target.value)}
            />
          </div>
          <div className="div-login">
            <label>
              Enter Branch Name <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              required
              name="branch-name"
              value={branchName}
              onChange={(e) => setBranchName(e.target.value)}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: ".5rem",
            }}
          >
            <button
              className="btn-login"
              type="submit"
              style={{ margin: "1rem 0" }}
            >
              Create User
            </button>
            <button type="button" className="btn-login" style={{margin:"1rem"}} onClick={() => navigate("/1")}>Back</button>
          </div>
        </form>
        <div className="table-wrapper-create-user">
          <table className="table-create-user">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email Id</th>
                {/* <th>Password</th> */}
                <th>Code</th>
                <th>Branch</th>
                <th>Edit</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((user, index) => {
                return (
                  <tr key={index}>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    {/* <td>{user.password}</td> */}
                    <td>{user.company_code}</td>
                    <td>{user.branchName}</td>
                    <td>
                    <Link to="/edit" state={user}>
                      <button className="btn-login">Edit</button></Link>
                    </td>
                    <td>
                      <button className="btn-login" onClick={() => handleDelete(user.email)}>Delete</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ToastContainer />
    </div>
  );
}
